import React from 'react';

import { useSelector } from '~/store';
import { selectFeatures, selectFeaturesLoaded } from '~/store/session';

export const useFeatureEnabled = (flag: string, defaultUntilLoaded = false) => {
  const userFeatures = useSelector(selectFeatures);
  const featuresLoaded = useSelector(selectFeaturesLoaded);

  if (!featuresLoaded) {
    return defaultUntilLoaded;
  }

  return userFeatures.includes(flag);
};

export interface FeatureGateProps {
  children: React.ReactNode;
  flag: string;
  fallback?: React.ReactNode;
}

const FeatureGate = ({ children, flag, fallback = null }: FeatureGateProps) => {
  const userHasFeature = useFeatureEnabled(flag);

  if (!userHasFeature) {
    return fallback;
  }

  return children;
};

export default FeatureGate;
